import {
  createDocument,
  createSavedPaymentAccountDeletionRequestById,
  EnumDocumentUploadStatus,
  updateDocumentStatusById,
} from "@/api/cashier";
import type { DeleteFormData } from "@/components/delete-saved-payment-dialog/types";
import { getSha256Hex, handleUpload } from "@/utils/presigned-upload-handler";

type DeleteRequest = {
  formData: DeleteFormData;
  savedPaymentAccountId: string;
  onProgress?: (progress: number) => void;
};

export const processDeleteRequest = async ({
  formData,
  savedPaymentAccountId,
  onProgress,
}: DeleteRequest) => {
  await createSavedPaymentAccountDeletionRequestById({
    body: {
      reason: formData.reason.value,
    },
    path: {
      savedPaymentAccountID: savedPaymentAccountId,
    },
    throwOnError: true,
  });

  if (formData.file) {
    const { data: document } = await createDocument({
      query: {
        "saved-payment-account-id": savedPaymentAccountId,
      },
      body: {
        name: formData.file.value.name,
        checksum: await getSha256Hex(formData.file.value),
      },
      throwOnError: true,
    });
    await handleUpload(
      document.presigned_url,
      formData.file.value,
      onProgress,
      document.fields
    );
    await updateDocumentStatusById({
      path: {
        documentID: document.document_id,
      },
      body: {
        status: EnumDocumentUploadStatus.EnumDocumentUploadStatusDone,
      },
      throwOnError: true,
    });
  }
};
